import { useStaticInfo } from "../hooks/useStaticInfo";

const useUserShippingAddress = (): string => {
  const {
    session: {
      user: {
        shippingAddress: {
          address: { address, city, postCode },
        },
      },
    },
  } = useStaticInfo();

  const userShippingAddress = [address, postCode, city].filter((removeEmpties) => removeEmpties);

  return userShippingAddress.join(", ");
};

export { useUserShippingAddress };
